import Vue from 'vue';
import * as VueGoogleMaps from "vue2-google-maps";

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyBTVtsU3rfKmIuIaHig_e6V0Glj0YNUx7U"
  }
});

Vue.use(VueGoogleMaps.Marker);